// Import the Firebase modules that you need in your app.
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

// Initalize and export Firebase.
const config = {
    apiKey: "AIzaSyD-LGp24n7e_yljwU23s_MVpGTvPHgSldw",
    authDomain: "davidson-wedding-website.firebaseapp.com",
    databaseURL: "https://davidson-wedding-website.firebaseio.com",
    projectId: "davidson-wedding-website",
    storageBucket: "davidson-wedding-website.appspot.com",
    messagingSenderId: "565604061322"
};
export default firebase.initializeApp(config);